import React from "react";
import PropTypes from "prop-types";
import { Grid, CircularProgress } from "@material-ui/core";

/**
 * Reusable loading spinner component
 */
export const LoadingSpinner = ({ show, padding = 100 }) => {
  if (!show) return null;

  return (
    <Grid
      style={{
        margin: "auto",
        padding,
        display: show ? "block" : "none",
      }}
    >
      <CircularProgress />
    </Grid>
  );
};

LoadingSpinner.propTypes = {
  show: PropTypes.bool.isRequired,
  padding: PropTypes.number,
};

